// src/mobile/navigation.ts
import { EventManager, setupEventListenersIfNeeded } from './event-manager';
import {
  NavigationBarConfig,
  NavigationItem,
  MoreMenuGroup,
  NavigationEventType,
} from './types';
import { postJsMessage } from '../../../bridge';
import API from '../../../api';

function processMenuItems(items: NavigationItem[]): NavigationItem[] {
  return items.map((item) => {
    if (item.onTap) {
      const eventType: NavigationEventType = 'onMoreMenuClick';
      const actionID = item.actionID;
      EventManager.getInstance().registerCallback(
        eventType,
        actionID,
        item.onTap
      );
      return { ...item, actionID };
    }
    return item;
  });
}

function processMenuGroups(groups: MoreMenuGroup[]): MoreMenuGroup[] {
  return groups.map((group) => ({
    ...group,
    items: processMenuItems(group.items),
  }));
}

export function setNavigationBarConfig(
  config: NavigationBarConfig
): Promise<any> {
  setupEventListenersIfNeeded();
  const processedConfig = { ...config };

  if (processedConfig.moreMenuContent?.itemsGroup) {
    processedConfig.moreMenuContent.itemsGroup = processMenuGroups(
      processedConfig.moreMenuContent.itemsGroup
    );
  }

  return postJsMessage(API.setNavigationBarConfig, processedConfig);
}
